import {
  FETCH_ROLES_REQUEST,
  FETCH_ROLES_SUCCESS,
  FETCH_ROLES_FAILURE,
  ADD_ROLE_SUCCESS,
  UPDATE_ROLE_SUCCESS,
  DELETE_ROLE_SUCCESS,
  SET_EDITING_ROLE,
  CLEAR_EDITING_ROLE
} from '../../../../types/masters/users/role/roleTypes';

const initialState = {
  list: [],
  loading: false,
  error: null,
  editingRole: null,
};

export default function roleReducer(state = initialState, action) {
  switch (action.type) {
    case FETCH_ROLES_REQUEST:
      return { ...state, loading: true, error: null };
    case FETCH_ROLES_SUCCESS:
      return { ...state, loading: false, list: action.payload };
    case FETCH_ROLES_FAILURE:
      return { ...state, loading: false, error: action.error };
    case ADD_ROLE_SUCCESS:
      return { ...state, list: [...state.list, action.payload] };
    case UPDATE_ROLE_SUCCESS:
      return {
        ...state,
        list: state.list.map(r => r.role_id === action.payload.role_id ? action.payload : r),
      };
    case DELETE_ROLE_SUCCESS:
      return {
        ...state,
        list: state.list.filter(r => r.role_id !== action.payload),
      };
    case SET_EDITING_ROLE:
      return { ...state, editingRole: action.payload };
    case CLEAR_EDITING_ROLE:
      return { ...state, editingRole: null };
    default:
      return state;
  }
}
